<template>
  <div class="attendanceButton text-center">
    <div class="row align-center justify-around hide-s">
      <img src="../../assets/img/button.png" />
      <i class="fa fa-arrows-h font-25"></i>
      <img src="../../assets/img/button2.png" />
    </div>
    <div class="row align-center justify-center hide-g hide-m">
      <img src="../../assets/img/buttonMobile.png" />
      &nbsp;
      <i class="fa fa-arrows-h font-25"></i>
      &nbsp;
      <img src="../../assets/img/buttonMobile2.png" />
    </div>
    <h2>Botão Atendimento</h2>
    <div class="text hide-s">
      Clicando na chave de disponibilidade você se torna <b>disponível</b> para
      realizar atendimentos, tendo acesso a novos Jobs mais rapidamente.
    </div>
    <div class="text hide-g hide-m">
      Clicando no botão com a logo da NS você se torna <b>disponível</b> para
      realizar atendimentos, tendo acesso a novos Jobs mais rapidamente.
    </div>
    <br />
    <br />
    <input type="checkbox" v-model="hide" @click="setHide" /> Não mostrar esta
    caixa novamente <br />
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.attendanceButton {
  color: white;
  background: $black;
  padding: 21px 33px;
  padding-bottom: 25px;
  border-radius: 23px;

  @media (min-width: $small) {
    width: 370px;
  }
  img {
    border-radius: 7px;
  }
}
</style>

<script>
export default {
  name: "attendanceButton",
  props: {
    modal: Object,
  },
  components: {},
  data() {
    return {
      count: 5,
      hide: false,
    };
  },
  methods: {
    setHide() {
      localStorage.setItem("atendimento", this.hide);
    },
  },
};
</script>
